import { createTypes } from '../../common/utils';

//create types
export default {
  GET_WIDGETS: createTypes('GET_WIDGETS'),
  GET_WIDGETS_PARENT_IDS: createTypes('GET_WIDGETS_PARENT_IDS'),
};
